import { Pipe, PipeTransform } from '@angular/core';
import {
  EmployeeRequestResponsibleForAnswerRequestableStatuses,
  EmployeeRequestResponsibleForAnswerStatusEnum,
  EmployeeRequestResponsibleForAnswerStatusLabels,
} from 'src/app/enums/employee-request-responsible-for-answer-status.enum';

type AbsenceRequestStatus = {
  value: string;
  label: string;
};

@Pipe({
  name: 'absenceRequestStatuses',
  standalone: true,
  pure: true,
})
export class AbsenceRequestStatusesPipe implements PipeTransform {
  transform(value: string): Array<AbsenceRequestStatus> {
    return [
      { value: value, label: 'Todos' },
      ...EmployeeRequestResponsibleForAnswerRequestableStatuses.map(
        (status: EmployeeRequestResponsibleForAnswerStatusEnum): AbsenceRequestStatus => {
          return {
            value: status,
            label: EmployeeRequestResponsibleForAnswerStatusLabels[status],
          };
        }
      ),
    ];
  }
}
